import type { RootState } from '../reducers';

export const getConversations = (state: RootState) => state.conversations.conversations;

export const getConversation = (state: RootState) => state.conversations.current;
